import BaseApiManager from '../../user/api/managers/BaseApiManager';

/**
 * Bids API Manager.
 */
export default class BidsApiManager extends BaseApiManager {

  /**
   * Create entity.
   *
   * @param {String} description
   * @param {String} comment
   *
   * @returns {Promise<any>}
   */
  async create(clientId, description) {
    if (clientId) {
      return await this.axios.post(this.url, {
        clientId,
        description,
      });
    }
    else {
      return await this.axios.post(this.url, {
        description,
      });
    }
  }

  /**
   * Get list bids.
   *
   * @param {Number} userId
   * @param {Number} perPage
   * @param {Number} page
   *
   * @returns {Promise<any>}
   */
  async list(userId, perPage, page) {
    let url;

    if (userId) {
      url = `${this.url}/users/${userId}/${perPage}/${page}`;
    }
    else {
      url = `${this.url}/${perPage}/${page}`;
    }

    return await this.axios.get(url, {
      perPage,
      page,
    });
  }

  /**
   * Update entity.
   *
   * @param {Number} id
   * @param {String} description
   * @param {String} comment
   *
   * @returns {Promise<any>}
   */
  async update(id, description, comment) {
    let url = `${this.url}/${id}`;

    return await this.axios.put(url, {
      description,
      comment,
    });
  }

  /**
   * Get assign-entities.
   *
   * @param id
   * @param {String} search
   * @param {Number} perPage
   * @param {Number} page
   *
   * @returns {Promise<any>}
   */
  async searchId(id, search = '', perPage = 1000, page = 1) {
    let url = `${this.url}/${id}/assign-entities`;

    return await this.axios.get(url, {
      params: {
        search,
        perPage,
        page
      }
    });
  }

  /**
   * Create assign.
   *
   * @param {Number} bidId
   * @param {Number} assignedId
   * @param {String} assignedType
   * @param {String} comment
   *
   * @returns {Promise<any>}
   */
  async assign(bidId, assignedId, assignedType, comment, description) {
    let url = `${this.url}/assign/`;

    return await this.axios.post(url, {
      bidId: bidId,
      assignedId: assignedId,
      assignedType: assignedType,
      comment: comment,
      description: description,
    });
  }

  /**
   * Set viewed.
   *
   * @param {Number} bidId
   * @param {Number} assignedId
   *
   * @returns {Promise<any>}
   */
  async viewed(bidId) {
    let url = `${this.url}/${bidId}/viewed/`;

    return await this.axios.put(url, {
      bidId: bidId
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/bids/api/BidsApiManager.ts